import { createFileRoute } from '@tanstack/react-router'

import { ConfiguratorSummaryPage } from '@/components/Customer/Configurator/Summary/ConfiguratorSummaryPage'

export const Route = createFileRoute(
  '/internal/customer-view/$userId/project/$projectId/summary',
)({
  component: ConfiguratorSummaryPage,
})
